import styles from "./PrivacyPolicy.module.scss";

const PrivacyPolicy: React.FC = () => {
  return (
    <main className={styles.container}>
      <h1>Privacy Policy</h1>
      <p>
        We respect the privacy and confidentiality of the personal data of our
        clients, customers, visitors and all others whom we interact with in the
        course of providing our services. While we are driven by the goal of
        providing customers with an enhanced shopping experience, we also
        understand that a key concern that customers may have is the safety of
        their personal information, and are committed to ensuring that all
        personal data provided to us remain secure and are only utilised for
        purposes that our customers have consented to.
      </p>
      <p>
        To begin with, we only collect such personal information that is
        necessary to provide you with the services that you have requested,
        understand your needs, and serve you better as a whole. We provide to
        our merchant partners only such information as is necessary to allow us
        to verify and track your rewards.
      </p>
      <p>We do not under any circumstance sell your information.</p>

      <h3>Privacy Policy</h3>
      <p>
        The purpose of this document is to inform you as to how ShopCash
        manages, collects, uses, and discloses Personal Data relating to you and
        other users of our website, software applications, mobile applications
        and other platforms. We conduct our business in compliance with the
        relevant data protection legislation,and have implemented additional
        measures to protect your personal information. The continued provision
        of our services to you and your continued use of such services shall be
        deemed to be our mutual agreement to abide by this Privacy Policy as
        updated from time to time on our website.
      </p>

      <h4>Personal Data</h4>
      <p>
        In this Privacy Policy, “Personal Data” refers to any data, whether true
        or not, about an individual who can be identified from that data, or
        from that data and other information to which we have or are likely to
        have access, including data in our records as may be updated from time
        to time.
      </p>

      <h4>Collection of Personal Data</h4>

      <p>
        The Personal Data that ShopCash may collect from you will depend on the
        products, services, and promotions that you use or subscribe to.
        ShopCash collects this data to enable our services and our platforms to
        function properly and to help us better understand how they work on
        different devices and browsers. Typically, ShopCash will collect
        Personal Data relating to you when you:
      </p>

      <ul>
        <li>
          Leave your contact details with us after visiting, using or installing
          (as the case may be) our websites, portals, mobile applications,
          social media platforms, or make enquiries via any other portal.
        </li>
        <li>
          Register for our services and/or submit any forms relating to any of
          our products and services.
        </li>
        <li>
          Sign up for alerts or newsletters or respond to our marketing
          collaterals e.g. advertisements, brochures or flyers.
        </li>
        <li>
          Contact us with enquiries or requests for assistance or interact or
          communicate with us or our employees, e.g. via our online interface,
          email, telephone calls, faxes, text messages or face-to-face meetings.
        </li>
        <li>
          Participate in competitions, lucky draws, surveys, or other such
          events.
        </li>
        <li>
          Submit your CV and job application forms to us or submit your CV to
          recruitment firms or job portals, who in turn forward the same to us.
        </li>
        <li>Are referenced to us by business partners or third parties.</li>
      </ul>

      <p>
        The Personal Data collected may include information relating to your:
      </p>

      <ul>
        <li>
          Identity: This includes your full name, e-mail address, date of birth,
          phone number, photographs, device ID, IP address, and payment-related
          information (e.g. bank account details or details of your account with
          a payment service provider such as PayPal).
        </li>
        <li>
          Interactions with us: This includes recordings of your phone calls
          with us, emails you sent, and other records of any contact you have
          with us.
        </li>
        <li>Account: Details relating to your ShopCash account.</li>
        <li>
          Use of our services: This includes using cookies or other browser
          related methods to track information relating to your interaction with
          our and our merchants’ websites (e.g. the pages within our website
          that you visit, the time spent on those pages, items and information
          searched on our site, access time and dates, webpages you were
          visiting prior to our site, and information relating to clicks and
          redirects).
        </li>
        <li>
          Preferences: This includes details that you have shared with us as to
          how you would like to be contacted, and your preferred products and
          brands.
        </li>
      </ul>

      <h4>Security of Personal Data</h4>
      <p>
        ShopCash ensures that all Personal Data collected will be safely and
        securely stored and has implemented stringent measures to secure and
        protect your information. These include:
      </p>
      <ul>
        <li>
          Using a secure, encrypted 128-bit SSL connection on all our web pages
          where you transmit Personal Data. 128-bit SSL encryption is the
          industry standard and is approximated to take at least one trillion
          years to crack.
        </li>
        <li>
          Ensuring that Personal Data relating to you is only stored on servers
          with proper safeguards to prevent security breaches.
        </li>
        <li>Limiting access to the information in our systems.</li>
        <li>
          Implementing strict verification processes to prevent unauthorized
          access to Personal Data.
        </li>
        <li>
          Securely destroying your personal information when it’s no longer
          needed for our business or legal processes.
        </li>
      </ul>

      <h4>Use of Personal Data</h4>
      <p>
        ShopCash does not sell or trade Personal Data collected online with
        third parties. We may use Personal Data relating to you to:
      </p>

      <ul>
        <li>Administer the services we provide you</li>
      </ul>

      <p>
        Primarily, we use your Personal Data to fulfil and process your orders
        and cashback. This would include using Personal Data relating to you to
        track your transactions with our merchant partners, credit cashback
        rewards into your ShopCash account, and process the necessary payments
        associated with such transactions. It would also include using Personal
        Data relating to you to activate or deactivate services, provide you
        with additional products, services, and benefits (such as promotions,
        loyalty programmes, or reward programmes), and administer (at times in
        conjunction with our preferred partners) promotional events, contests,
        competitions, and corporate social responsibility projects.
      </p>

      <ul>
        <li>Enhance the services we provide you</li>
      </ul>

      <p>
        We use your Personal Data to investigate complaints, claims and
        disputes. We also use your Personal Data to improve site and service
        performance and the delivery of our services, such as when you make
        inquiries into and provide feedback on our quality of service. We may
        also use Personal Data relating to you to conduct, understand your
        preferences, develop new products and services, or personalize or
        otherwise improve the products and services we offer you. It would also
        include using Personal Data relating to you to deliver relevant
        advertising (such as that involving details of our or our preferred
        partners’ products, services, special offers, and rewards), either to
        our customers generally, or which we have identified may be of interest
        to you in particular, to deliver periodic newsletters to you with your
        prior consent or if otherwise permitted under local laws and
        regulations, or to promote benefits and offer rewards and promotions
        that you qualify for.
      </p>

      <ul>
        <li>Customer Service</li>
      </ul>
      <p>
        This would include using Personal Data relating to you to respond to
        requests and enquiries made by you (or persons authorised by you),
        provide you with directory assistance, and provide you with updates
        relating to our products, services, or policies.
      </p>

      <ul>
        <li>Security and Compliance</li>
      </ul>
      <p>
        This would include using Personal Data relating to you to detect and
        prevent fraud and other crimes (e.g. by conducting checks against money
        laundering, terrorism financing and related risks), conducting internal
        audits, or otherwise meeting legal, regulatory and other requirements
        (including providing assistance to law enforcement, judicial, and other
        government agencies, responding to regulatory complaints, making
        relevant disclosures to regulatory bodies, conducting audit checks, due
        diligence and investigations, and taking steps which ShopCash considers
        necessary in the event of a lawsuit or potential lawsuit). It would also
        include using Personal Data relating to you for the purposes of security
        and risk management and to ensure the safety and security of our
        properties and systems.
      </p>

      <ul>
        <li>Job applications</li>
      </ul>

      <p>
        This would include processing job applications, recruitment and
        selection and processing and administering employment records.
      </p>

      <p>
        We will not use Personal Data relating to you for purposes other than
        what we have informed you, or which we are permitted or required under
        local law and regulations.
      </p>

      <p>
        We will only retain Personal Data relating to you for only as long as
        there is a business or legal need.
      </p>

      <h4>Sharing of Personal Data</h4>

      <p>We may share Personal Data relating to you with:</p>

      <ul>
        <li>
          ShopCash’s business partners, vendors, agents, and service providers
          who we work with to deliver services you have subscribed to. This
          would include merchant partners, payment service providers, third
          party service providers engaged in connection with marketing
          promotions and services offered by ShopCash or its preferred partners,
          and third party service providers who provide operational services to
          ShopCash (such as telecommunications, information technology, payment,
          printing, billing, payroll, processing, technical services, training,
          market research, call centre or other services to ShopCash). It also
          includes our professional advisers such as auditors and lawyers.
        </li>
        <li>
          In the event of an actual or prospective business asset transaction
          (such as any merger, acquisition or asset sale), any business partner,
          investor, assignee, or transferee for the purposes of facilitating
          such a transaction.
        </li>
        <li>
          Relevant regulators, statutory boards or authorities, or law
          enforcement agencies as required by any laws, rules, guidelines, and
          regulations or schemes.
        </li>
      </ul>

      <h4>Newsletter</h4>
      <p>
        When you register as a user on ShopCash, we will also use Personal Data
        that you have provided to send you promotional e-mails from time to time
        so as to update you about the latest offers, rewards, deals, products,
        or services from ShopCash or our preferred partners. You can unsubscribe
        from our promotional e-mails at any time through the unsubscribe
        function within the promotional e-mails.
      </p>

      <h4>Disclosure to Digital Advertising Providers</h4>
      <p>
        To provide us with advertising and marketing services, we partner with
        certain third parties that automatically collect Internet and Network
        Activity information about your use of the Services, such as your
        browsing history, IP address, pages viewed, and links clicked, so that
        they can use this information to serve you ads for our Services on other
        sites. These third parties may also use this collected information to
        draw inferences about you for their own purposes, or collect personal
        information about your online activities over time and across different
        websites (in addition to our Services) to help predict your preferences
        and to display (and enable other third parties to display) ads to you
        that are more likely to be of interest to you. Note that this Privacy
        Policy covers only our use of data and does not include use of data by
        such third parties.
      </p>

      <h4>Updating Personal Data</h4>
      <p>
        You can update your personal information any time by accessing your
        account on ShopCash website. If there is any Personal Data relating to
        you that you are unable to update through the ShopCash website and which
        you wish to make corrections to, you may contact us at
        contact@shopcash.com and we will be glad to help you as best as we can.
      </p>

      <h4>Respecting your Consent and Access to Personal Data</h4>
      <p>
        If you wish to access the Personal Data that we have relating to you,
        inquire about the ways in which Personal Data relating to you has been
        or may have been used or disclosed by ShopCash within the past year, or
        wish to withdraw your consent to our use of such Personal Data, you may
        contact us at contact@shopcash.com . We will seek to attend to your
        request as best as we reasonably can.
      </p>

      <p>
        Kindly note however that we may have to charge you a reasonable
        administrative fee for retrieving Personal Data relating to you.
      </p>

      <p>
        Please note that you may withdraw your consent to our collection, use
        and disclosure of your information at any time. However, do kindly also
        note that if you withdraw your consent to our use and/or disclosure of
        Personal Data relating to you, depending on the nature of your
        objection, we may not be in a position to continue to provide our
        products or services to you or perform on any contract we have with you.
        Our legal rights and remedies are expressly reserved in such event.
      </p>

      <h4>Deleting your Personal Data</h4>
      <p>
        If you wish to delete your account and associated personal data, please
        write to us at contact@shopcash.com to submit your request. Please make
        sure you write from your ShopCash registered email address. Subsequently
        we may require identification and verification documents from you to
        establish your identity when you exercise any applicable legal rights to
        remove your personal data.
      </p>
      <p>
        Please take note of the following caveats when requesting data deletion:
      </p>
      <ul>
        <li>Any remaining cashbacks in your account will be forfeited.</li>

        <li>Any pending withdrawals in your account will also be forfeited.</li>

        <li>ShopCash will delete all your personal information.</li>

        <li>
          ShopCash will continue to hold your transactional data for financial
          audit purposes.
        </li>

        <li>You will not be able to login into a deleted account.</li>
      </ul>

      <h4>Changes to the Privacy Policy</h4>
      <p>
        ShopCash reserves the right to modify and update the Privacy Policy at
        any time to ensure that it is consistent with industry trends and/or any
        changes in legal or regulatory requirements. Subject to your rights at
        law, you agree to be bound by the prevailing terms of the Privacy Policy
        as updated from time to time on our website. Any changes to this policy
        will be published on our website.
      </p>

      <h4>Governing Law</h4>
      <p>
        This Privacy Policy and your use of this website shall be governed in
        all respects by the laws of the country which you are in.
      </p>

      <p>Updated: 24/05/2022</p>
    </main>
  );
};

export default PrivacyPolicy;
